export const urls = {
  jobApplication: {
    usage: "/zyra/v1/usage-management/configs/users/",
  },
}
